const triggerRoiGateFormLastNameFieldGoogleAnalyticsEvent = require("../../run/roiCalculator/triggerRoiGateFormLastNameFieldGoogleAnalyticsEvent");

/**
 * @return {void}
 */
module.exports = function whenFirstRoiGateFormLastNameFieldUpdate() {
    triggerRoiGateFormLastNameFieldGoogleAnalyticsEvent();
}
